import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/fe-essentials/panorama-client';
import { useEffect, useMemo, useState } from 'react';
import { injectScript } from './sentry-script';
const globalConfig = createGlobalConfig();
const panoramaFactory = _ref => {
  let {
    esi,
    msid
  } = _ref;
  return panoramaClientFactory({
    baseParams: {
      componentId: 'a11y-wizard',
      fullArtifactId: 'com.wixpress.a11y-wizard',
      msid,
      platform: PanoramaPlatform.Standalone
    },
    data: {
      esi,
      msid
    },
    pluginParams: {
      // @ts-expect-error
      sentry: window.Sentry,
      sentryDsn: 'https://60a5e76e3a6145ed8d9c7edcad1f94f1@sentry-next.wixpress.com/17855',
      sentryMain: true
    }
  }).withGlobalConfig(globalConfig);
};
export const useCreatePanoramaClient = _ref2 => {
  let {
    msid,
    esi
  } = _ref2;
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  useEffect(() => {
    injectScript(() => {
      setIsScriptLoaded(true);
    });
  }, []);
  return useMemo(() => {
    return isScriptLoaded ? panoramaFactory({
      esi,
      msid
    }).client({
      baseParams: {
        componentId: 'a11y-wizard',
        fullArtifactId: 'com.wixpress.a11y-wizard',
        msid,
        platform: PanoramaPlatform.Standalone
      },
      data: {
        esi,
        msid
      },
      pluginParams: {}
    }) : undefined;
  }, [esi, isScriptLoaded, msid]);
};
//# sourceMappingURL=use-create-panorama-client.js.map